module.exports = __webpack_public_path__ + "363066be923fc6523f26258b4d17beea.mp3";